<script>
</script>

<style>
  .duvidas-container {
    background-color: #f9f9f9;
    padding: 40px;
    text-align: center;
  }

  .duvidas-titulo {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .duvidas-button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
  }
</style>

<div class="duvidas-container">
  <div class="duvidas-titulo">Tem alguma dúvida?</div>
  <button class="duvidas-button">Entre em contato</button>
</div>
